import React, { useCallback } from 'react';
import i18n from '../../../i18n';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';

import { useAction } from 'core/store/store';

import { isUIEnabledSelector } from 'state/app/selectors';

import { Button, ButtonColor } from 'components/Button/Button';
import { Icon } from 'components/Icon/Icon';
import { Text, TextTypography } from 'components/Text/Text';

import { ReactComponent as LinkIcon } from 'assets/icons/main-16/external-link-o--16.svg';


import { getClientUrl } from 'core/utils/utils';

const useStyles = makeStyles(theme => ({
    footer: {
        alignItems: 'center',
        borderTop: `1px solid ${theme.palette.brandPrimary.lightest}`,
        display: 'flex',
        height: theme.spacing(9),
        padding: theme.spacing(0, 3),
    },
    footerContent: {
        flex: 1,
    },
    footerButtons: {
        flexBasis: 'auto',
    },
    link: {
        cursor: 'pointer',
        display: 'inline-block',
    },
    linkIcon: {
        marginRight: theme.spacing(1),
        verticalAlign: 'middle',
    },
    linkText: {
        verticalAlign: 'middle',
    },
}));

export const DefaultFooter = () => {
    const { t } = i18n.useTranslation();
    const isUIEnabled = useSelector(isUIEnabledSelector);

    const action = useAction();

    const handleRedirectToFeed = useCallback(() => {
        window.open(getClientUrl(), '_blank')
    }, [action, history]);

    const classes = useStyles();
    return (
        <footer className={classes.footer}>
            <div className={classes.footerContent}>
                <div className={classes.link} onClick={handleRedirectToFeed}>
                    <Icon className={classes.linkIcon} component={LinkIcon} size={16} svgSize={16} />
                    <Text className={classes.linkText} typography={TextTypography.BODY_ACCENT}>
                        {t('onboarding:footer.aboutLink')}
                    </Text>
                </div>
            </div>
            <div className={classes.footerButtons}>
                <Button color={ButtonColor.SUCCESS} disabled={!isUIEnabled} type="submit">
                    {t('onboarding:footer.nextButton')}
                </Button>
            </div>
        </footer>
    );
};
